// Import all projections from the separate projections file
import {
	// USER_INFO_FIELDS,
	// ENGAGEMENT_FIELDS,
	// ENGAGEMENT_EXTENDED_FIELDS,
	// ENGAGEMENT_PODCAST_FIELDS,
	PAGINATION_FIELDS,
	// THUMBNAIL_FIELDS,
	// THUMBNAIL_WITH_DIMENSIONS,
	// ACCESS_CONTROL_FIELDS,
	// CONTENT_META_FIELDS,
	// VIDEO_FILE_FIELDS,
	// IMAGE_FILE_FIELDS,
	// DOCUMENT_FILE_FIELDS,
	ARTICLE_PROJECTION,
	VIDEO_PROJECTION,
	PODCAST_PROJECTION,
	IMAGE_PROJECTION,
	DOCUMENT_PROJECTION,
	PLAYLIST_PROJECTION,
	CATEGORY_PROJECTION
	// SEARCH_ARTICLE_PROJECTION,
	// SEARCH_VIDEO_PROJECTION,
	// SEARCH_PODCAST_PROJECTION,
	// SEARCH_IMAGE_PROJECTION,
	// SEARCH_DOCUMENT_PROJECTION,
	// SEARCH_PLAYLIST_PROJECTION,
	// SEARCH_CATEGORY_PROJECTION,
	// SEARCH_SUBCATEGORY_PROJECTION
} from './content_projections';

// ===== GRAPHQL QUERIES =====

// Article-specific query
export const ARTICLE_CONTENT_QUERY = `
  query GetArticleContent(
    $companyId: ID!
    $filters: ContentFilterInput
    $page: Int
    $limit: Int
    $sort: ContentSortInput
    $from: String
  ) {
    companyContent(
      companyId: $companyId
      filters: $filters
      page: $page
      limit: $limit
      sort: $sort
      from: $from
    ) {
      success
      data {
        ${ARTICLE_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// Video-specific query
export const VIDEO_CONTENT_QUERY = `
  query GetVideoContent(
    $companyId: ID!
    $filters: ContentFilterInput
    $page: Int
    $limit: Int
    $sort: ContentSortInput
    $from: String
  ) {
    companyContent(
      companyId: $companyId
      filters: $filters
      page: $page
      limit: $limit
      sort: $sort
      from: $from
    ) {
      success
      message
      data {
        ${VIDEO_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;
// need to add favorites to the video projection
// favorites { name sub userId}

// Podcast-specific query
export const PODCAST_CONTENT_QUERY = `
  query GetPodcastContent(
    $companyId: ID!
    $filters: ContentFilterInput
    $page: Int
    $limit: Int
    $sort: ContentSortInput
    $from: String
  ) {
    companyContent(
      companyId: $companyId
      filters: $filters
      page: $page
      limit: $limit
      sort: $sort
      from: $from
    ) {
      success
      message
      data {
        ${PODCAST_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// Image-specific query
export const IMAGE_CONTENT_QUERY = `
  query GetImageContent(
    $companyId: ID!
    $filters: ContentFilterInput
    $page: Int
    $limit: Int
    $sort: ContentSortInput
    $from: String
  ) {
    companyContent(
      companyId: $companyId
      filters: $filters
      page: $page
      limit: $limit
      sort: $sort
      from: $from
    ) {
      success
      message
      data {
        ${IMAGE_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// Document-specific query
export const DOCUMENT_CONTENT_QUERY = `
  query GetDocumentContent(
    $companyId: ID!
    $filters: ContentFilterInput
    $page: Int
    $limit: Int
    $sort: ContentSortInput
    $from: String
  ) {
    companyContent(
      companyId: $companyId
      filters: $filters
      page: $page
      limit: $limit
      sort: $sort
      from: $from
    ) {
      success
      data {
        ${DOCUMENT_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// Playlist-specific query
export const PLAYLIST_CONTENT_QUERY = `
  query GetPlaylistContent(
    $companyId: ID!
    $filters: ContentFilterInput
    $page: Int
    $limit: Int
    $from: String
    $sort: ContentSortInput
  ) {
    companyContent(
      companyId: $companyId
      filters: $filters
      page: $page
      limit: $limit
      from: $from
      sort: $sort
    ) {
      success
      data {
        ${PLAYLIST_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// Category-specific query
export const CATEGORY_CONTENT_QUERY = `
  query GetCategoryContent(
    $companyId: ID!
    $filters: ContentFilterInput
    $page: Int
    $limit: Int
    $sort: ContentSortInput
    $from: String
  ) {
    companyContent(
      companyId: $companyId
      filters: $filters
      page: $page
      limit: $limit
      sort: $sort
      from: $from
    ) {
      success
      data {
        ${CATEGORY_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// Company Playlists query
export const GET_COMPANY_PLAYLISTS_QUERY = `
  query GetCompanyPlaylists(
    $companyId: ID!
    $page: Int
    $limit: Int
    $filters: PlaylistFilterInput
    $sort: PlaylistSortInput
    $from: String
  ) {
    companyPlaylists(
      companyId: $companyId
      page: $page
      limit: $limit
      filters: $filters
      sort: $sort
      from: $from
    ) {
      success
      message
      data {
        _id
        name
        description
        items {
          contentId
          title
          contentType
          addedAt
          addedBy {
            _id
            name
          }
        }
        visibility
        enabled
        allowShare
        allowDownload
        views
        contentCount
        createdAt
        updatedAt
        accessControl {
          internalEmployees {
            allSelected
            departments {
              name
              count
            }
            specificUsers {
              userId
              email
              name
              role
            }
          }
          userGroups {
            type
            count
          }
          participantCount
          participantLimit
        }
        createdBy {
          _id
          userId
          name
        }
        updatedBy {
          _id
          userId
          name
        }
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// ===== SEARCH CONTENT QUERIES =====

// Article search query
export const SEARCH_ARTICLE_QUERY = `
  query SearchArticles(
    $companyId: ID!
    $searchTerm: String!
    $page: Int
    $limit: Int
    $filters: ArticleFilterInput
    $sort: ArticleSortInput
    $from: String
  ) {
    searchArticles(
      companyId: $companyId
      searchTerm: $searchTerm
      page: $page
      limit: $limit
      filters: $filters
      sort: $sort
      from: $from
    ) {
      success
      message
      data {
        ${ARTICLE_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// Video search query
export const SEARCH_VIDEO_QUERY = `
  query SearchVideos(
    $companyId: ID!
    $searchTerm: String!
    $page: Int
    $limit: Int
    $filters: VideoFilterInput
    $sort: VideoSortInput
    $from: String
  ) {
    searchVideos(
      companyId: $companyId
      searchTerm: $searchTerm
      page: $page
      limit: $limit
      filters: $filters
      sort: $sort
      from: $from
    ) {
      success
      message
      data {
        ${VIDEO_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// Podcast search query
export const SEARCH_PODCAST_QUERY = `
  query SearchPodcasts(
    $companyId: ID!
    $searchTerm: String!
    $page: Int
    $limit: Int
    $filters: PodcastFilterInput
    $sort: PodcastSortInput
    $from: String
  ) {
    searchPodcasts(
      companyId: $companyId
      searchTerm: $searchTerm
      page: $page
      limit: $limit
      filters: $filters
      sort: $sort
      from: $from
    ) {
      success
      message
      data {
        ${PODCAST_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// Image search query
export const SEARCH_IMAGE_QUERY = `
  query SearchImages(
    $companyId: ID!
    $searchTerm: String!
    $page: Int
    $limit: Int
    $filters: ImageFilterInput
    $sort: ImageSortInput
    $from: String
  ) {
    searchImages(
      companyId: $companyId
      searchTerm: $searchTerm
      page: $page
      limit: $limit
      filters: $filters
      sort: $sort
      from: $from
    ) {
      success
      message
      data {
        ${IMAGE_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// Document search query
export const SEARCH_DOCUMENT_QUERY = `
  query SearchDocuments(
    $companyId: ID!
    $searchTerm: String!
    $page: Int
    $limit: Int
    $filters: DocumentFilterInput
    $sort: DocumentSortInput
    $from: String
  ) {
    searchDocuments(
      companyId: $companyId
      searchTerm: $searchTerm
      page: $page
      limit: $limit
      filters: $filters
      sort: $sort
      from: $from
    ) {
      success
      message
      data {
        ${DOCUMENT_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// Playlist search query
export const SEARCH_PLAYLIST_QUERY = `
  query SearchPlaylists(
    $companyId: ID!
    $searchTerm: String!
    $page: Int
    $limit: Int
    $filters: PlaylistFilterInput
    $sort: PlaylistSortInput
    $from: String
  ) {
    searchPlaylists(
      companyId: $companyId
      searchTerm: $searchTerm
      page: $page
      limit: $limit
      filters: $filters
      sort: $sort
      from: $from
    ) {
      success
      message
      data {
        _id
        companyId
        isFavoritedByMe
        name
        description
        thumbnailUrl
        items {
          contentId
          title
          contentType
          addedAt
          thumbnailUrl
          addedBy {
            _id
            userId
            name
            subId
          }
        }
        visibility
        enabled
        allowShare
        allowDownload
        views
        contentCount
        createdAt
        updatedAt
        accessControl {
          internalEmployees {
            allSelected
            departments {
              name
              count
            }
            specificUsers {
              userId
              email
              name
              role
              subId
            }
          }
          userGroups {
            type
            count
          }
          participantCount
          participantLimit
        }
        createdBy {
          _id
          userId
          name
          subId
        }
        updatedBy {
          _id
          userId
          name
          subId
        }
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

// Category search query
export const SEARCH_CATEGORY_QUERY = `
  query SearchCategories(
    $companyId: ID!
    $searchTerm: String!
    $page: Int
    $limit: Int
    $from: String
  ) {
    searchCategories(
      companyId: $companyId
      searchTerm: $searchTerm
      page: $page
      limit: $limit
      from: $from
    ) {
      success
      message
      data {
        ${CATEGORY_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;

export const SEARCH_SUBCATEGORY_QUERY = `
  query SearchSubcategories(
    $companyId: ID!
    $searchTerm: String!
    $parentCategoryId: ID
    $page: Int
    $limit: Int
    $from: String
  ) {
    searchSubcategories(
      companyId: $companyId
      searchTerm: $searchTerm
      parentCategoryId: $parentCategoryId
      page: $page
      limit: $limit
      from: $from
    ) {
      success
      message
      data {
        ${CATEGORY_PROJECTION}
      }
      pagination {
        ${PAGINATION_FIELDS}
      }
    }
  }
`;